import axios from 'axios'
import getDomainName from 'helpers/getDomainName'
import { handleError } from 'helpers/api-error-handler'

export default function skmExport(url, requestData) {
  return new Promise((resolve, reject) => {
    const request = axios({
      method: 'POST',
      url: url,
      data: requestData,
      responseType: 'json',
      // timeout:1000000,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    request
      .then(response => {
        resolve(response?.data)
      })
      .catch(error => {
        console.error('API Error:', error.response || error.message)
        reject(error)
      })
  })
}
